import { render } from "./TextareaLabel.vue?vue&type=template&id=8a7e5f98&scoped=true"
import script from "./TextareaLabel.vue?vue&type=script&lang=js"
export * from "./TextareaLabel.vue?vue&type=script&lang=js"

import "./TextareaLabel.vue?vue&type=style&index=0&id=8a7e5f98&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a7e5f98"]])

export default __exports__